import React, { FC } from 'react'
import BagPolaroidIcon from 'svg/bag-polaroid-v2.svg'
import BagPolaroidFilledIcon from 'svg/bag-polaroid-filled-v2.svg'
import styles from './Actions.module.scss'
import classNames from 'classnames'
import useAddToCart, { GA4CartEventObject } from './useAddToCart'
import { ARTWORK_STATUS } from '../helpers'
import AlgoliaConnector, { AlgoliaConnectorProps } from './AlgoliaConnector'

type AddToCartProps = AlgoliaConnectorProps & {
  isAddedToCart?: boolean
  sku: string
  status: string
  artworkId: number
  price: number
  productEvent: GA4CartEventObject
  customPromoCode?: string
}

const AddToCart: FC<AddToCartProps> = ({
  isAddedToCart,
  sku,
  status,
  searchIndice,
  algoliaUserToken,
  userId,
  artworkId,
  productEvent,
  price,
  customPromoCode,
}) => {
  const {
    handleClickAddToCart,
    handleClickAddToCartWithPromoCode,
    shouldBlockEvents,
  } = useAddToCart({
    sku,
    searchIndice,
    algoliaUserToken,
    userId,
    artworkId,
    productEvent,
    price,
    customPromoCode,
  })

  if (!sku || status !== ARTWORK_STATUS.AVAILABLE) {
    return null
  }

  return (
    <button
      className={classNames(styles.iconButtonDefaultStyle, styles.iconActionContainer)}
      data-action='cart'
      data-type='action'
      title='Add to Cart'
      rel='nofollow'
      onClick={customPromoCode ? handleClickAddToCartWithPromoCode : handleClickAddToCart}
      disabled={shouldBlockEvents}
    >
      <BagPolaroidFilledIcon
        className={classNames(styles.iconActionAddToCart, {
          [styles.iconActionContainerInvisible]: !isAddedToCart,
        })}
      />
      {!isAddedToCart && <BagPolaroidIcon className={styles.iconActionAddToCart} />}
    </button>
  )
}

export default AlgoliaConnector(AddToCart)
